<template>
  <div class="profile-info-block">
    <h2 class="rg-title">職歴</h2>
    <div class="table-responsive">
      <table class="table">
        <tbody>
        <tr>
          <th>直近在籍企業名</th>
          <td>{{history.lastCompany}}</td>
        </tr>
        <tr>
          <th>在籍年数</th>
          <td>{{history.yearsAttended}}</td>
        </tr>
        <tr>
          <th>直近職種</th>
          <td>{{lastJob}}</td>
        </tr>
        <tr>
          <th>雇用形態</th>
          <td>{{history.status.title}}</td>
        </tr>
        <tr>
          <th>役職</th>
          <td><span class="edit-txt" v-if="history.position">{{history.position.title}}</span></td>
        </tr>
        <tr>
          <th>英語力</th>
          <td>{{history.englishSkill.title}}</td>
        </tr>
        <tr>
          <th>直近年収 (万円)</th>
          <td>{{history.lastYearIncome}}</td>
        </tr>
        <tr>
          <th>これまでの経験社数</th>
          <td>{{history.experienceCompanies}}</td>
        </tr>
        <tr>
          <th>現在の就業状況</th>
          <td>{{history.employmentSituation}}</td>
        </tr>
        <tr>
          <th>職務要約</th>
          <td style="white-space: pre-wrap !important">{{history.summary}}</td>
        </tr>
        <tr>
          <th>転職意向</th>
          <td v-if="history.screeningIntention">{{history.screeningIntention.title}}</td>
        </tr>
        <tr>
          <th>職務経歴書作成状況</th>
          <td v-if="history.jobHistoryRecord">{{history.jobHistoryRecord.title}}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div><!-- ends profile-info-block -->
</template>

<script>
export default {
  name: 'DEmploymentInfo',
  props: {
    history: {
      required: true,
    },
  },
  computed: {
    lastJob() {
      const { lastJob } = this.history;
      const { child } = lastJob;
      return `${lastJob.title} / ${child.title}`;
    },
  },
  mounted() {
    this.$emit('employmentLoaded');
  },
};
</script>

<style scoped>
</style>
